module.exports = __webpack_public_path__ + "img/task-setup-nodata.7caa90ac.png";